export default "__VITE_ASSET__BKQxFYNe__"